// src/pages/InventoryTrackerPage.jsx
import React from 'react';
import UserLayout from '../components/UserLayout';
import SampleDistributionLog from '../components/SampleDistributionLog';

const SampleDistributionLogPage = () => {
  return (
    <UserLayout>
      <SampleDistributionLog />
    </UserLayout>
  );
};

export default SampleDistributionLogPage;